<!-- Content Header (Page header) -->
<section class="content-header">
  <div class="container-fluid">
      <div class="row mb-2">
          <div class="col-sm-6">
              <h1>{{keyword?.word}}</h1>
          </div>
          <div class="col-sm-6">
              <ol class="breadcrumb float-sm-right">
                  <li class="breadcrumb-item"><a href="/admin">Ana Sayfa</a></li>
                  <li class="breadcrumb-item"><a href="/coursedetail/{{keyword?.phase?.level?.courseId}}">{{keyword?.phase?.level?.course?.from?.name}}-{{keyword?.phase?.level?.course?.to?.name}}</a></li>
                  <li class="breadcrumb-item"><a href="/leveldetail/{{keyword?.phase?.levelId}}">{{keyword?.phase?.level?.name}}</a></li>
                  <li class="breadcrumb-item"><a href="/phasedetail/{{keyword?.phaseId}}">{{keyword?.phase?.name}}</a></li>
                  <li class="breadcrumb-item active">{{keyword?.word}}</li>
              </ol>
          </div>
      </div>
  </div>
  <!-- /.container-fluid -->
</section>

<!-- Main content -->
<section class="content">
  <!-- Default box -->
  <div class="container-fluid">
      <div class="card">
          <div class="card-header">
              <h3 class="card-title">Kelime Detayı</h3>

             
          </div>
          <div class="card-body">

            <p><b>Öğrenilecek Kelime:</b> {{keyword?.word}}</p>
            <p><b>Tercümesi:</b> {{keyword?.translate}}</p>
            <p><b>Youtube:</b> {{keyword?.youTube}}</p>
            <p><b>Kodu:</b> {{keyword?.code}}</p>
            <p><b>Tipi:</b> {{keyword?.type}}</p>
            <p><b>Kategori:</b> {{keyword?.category}}</p>
            <p><b>Sıra no:</b> {{keyword?.order}}</p>
            <p><b>Örnek Cümle:</b> {{keyword?.sentence}}</p>
            <p><b>Örnek Cümle Çevirisi:</b> {{keyword?.translatedSentence}}</p>
            <p><b>Premium mu?:</b> {{keyword?.isPremium}}</p>
            <p><b>Duvar Kağıdı Varmı?:</b> {{keyword?.hasWallpaper}}</p>
            <p><b>İcon:</b><img src="{{keyword?.icon}}" width="100"></p>
            <p><b>Duvar Kağıdı:</b><img src="{{keyword?.wallpaper}}" width="100"></p>
            <p><b>Premium Duvar Kağıdı:</b><img src="{{keyword?.premiumWallpaper}}" width="100"></p>
            <p><b>Duvar kağıdı yazılımı</b> {{keyword?.hasText}}</p>
            <p><b>Premium duvar kağıdı yazılımı:</b> {{keyword?.premiumHasText}}</p>

            <p><b>Soru Tipi:</b> {{getQuestionType(keyword?.questionType)}}</p>
            <p><b>Seçenek1:</b> {{keyword?.option1}}</p>
            <p><b>Seçenek2:</b> {{keyword?.option2}}</p>
            <p><b>Seçenek3:</b> {{keyword?.option3}}</p>

            <p><b>Seçenek1 Anadil:</b> {{keyword?.optionMother1}}</p>
            <p><b>Seçenek2 Anadil:</b> {{keyword?.optionMother2}}</p>
            <p><b>Seçenek3 Anadil:</b> {{keyword?.optionMother3}}</p>
            <p>
              <a href="{{keyword?.licence}}" target="_blank">Lisans indir</a>
            </p>
            <p><b> Soru:</b> {{keyword?.question}}</p>
            <p><b>Soru Anlamları:</b>{{keyword.wordMeanings}}</p>
            <p><b>Movie:</b>{{keyword.movie}}</p>

          </div>
          <!-- /.card-body -->
          <div class="card-footer"></div>
          <!-- /.card-footer-->
      </div>
  </div>
  <!-- /.card -->

  <div class="container-fluid">
    <app-social-card [keyword]="keyword"></app-social-card>
  </div>

</section>
<!-- /.content -->
